


import watchNewPatrimonioAlertaManutencaoCadastro from './saga/new';
import watchNewFilterPatrimonioAlertaManutencao from './saga/newFilter';
import watchNewFilterNextPagePatrimonioAlertaManutencao from './saga/newFilterNextPage';
import watchFindPatrimonioAlertaManutencaoCadastro from './saga/find';
import watchCreatePatrimonioAlertaManutencaoCadastro from './saga/create';
import watchListAllPatrimonioAlertaManutencaoCadastro from './saga/listAll';
import watchListPatrimonioAlertaManutencaoCadastro from './saga/listTable';
import watchDeletePatrimonioAlertaManutencaoCadastro from './saga/delete';
import watchCancelPatrimonioAlertaManutencaoCadastroRapido from './saga/cancel';

export const patrimonioAlertaManutencaoCadastroSaga = [
    watchNewPatrimonioAlertaManutencaoCadastro(),
    watchNewFilterPatrimonioAlertaManutencao(),
    watchNewFilterNextPagePatrimonioAlertaManutencao(),
    watchFindPatrimonioAlertaManutencaoCadastro(),
    watchCreatePatrimonioAlertaManutencaoCadastro(),
    watchListAllPatrimonioAlertaManutencaoCadastro(),
    watchListPatrimonioAlertaManutencaoCadastro(),
    watchDeletePatrimonioAlertaManutencaoCadastro(),
    watchCancelPatrimonioAlertaManutencaoCadastroRapido(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
